import Index from "./pages/Index";

const routes = [
  { path: "/index", component: Index },
  { path: "/", component: Index },
];

export default routes;
